import React from "react";

const PromoImages = ({ showAll = false }) => {
  return (
    <div className="promoImages">
      {showAll && (
        <div className="logo">
          <img src="/assets/images/promo/byblack.svg" alt="" />
        </div>
      )}
      <div className="logo" style={{ width: showAll ? "33%" : "50%" }}>
        <p>Powered by</p>

        <img src="/assets/images/promo/usbc-logo.svg" alt="" />
      </div>
      <div className="logo" style={{ width: showAll ? "33%" : "50%" }}>
        <p>Presented by</p>
        <img src="/assets/images/promo/Americanexpress.svg" alt="" />
      </div>
    </div>
  );
};

export default PromoImages;
